import { render, staticRenderFns } from "./Designtwo.vue?vue&type=template&id=90e8e7ea&scoped=true"
import script from "./Designtwo.vue?vue&type=script&lang=js"
export * from "./Designtwo.vue?vue&type=script&lang=js"
import style0 from "./Designtwo.vue?vue&type=style&index=0&id=90e8e7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e8e7ea",
  null
  
)

export default component.exports